import { useState } from 'react';
import Popup from '../components/Popup.tsx';
import CancelIcon from '/asset/close.svg';
import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store.ts';
const PAY_SMALL_SMALL_BAR_COOKIE = 'paySmallSmallBarHidden';

export default function BNPLBar() {
  const { storeInfo } = useSelector((state: RootState) => state.products);
  const { companyId } = useSelector((state: RootState) => state.setup);
  const [showPaySmallSmallInfo, setShowPaySmallSmallInfo] = useState(false);
  const [isPaySmallSmallBarHidden, setIsPaySmallSmallBarHidden] = useState(
    () => Cookies.get(PAY_SMALL_SMALL_BAR_COOKIE) === 'true'
  );
  return (
    <div>
      <Popup
        isOpen={showPaySmallSmallInfo}
        onClose={() => setShowPaySmallSmallInfo(false)}
        closeClass="!bg-[#714DFF] w-[30px] h-[30px] p-1 flex justify-center rounded-full hover:border-none hover:bg-[#714DFF]"
        popUpClass="!p-0 w-[90%] max-w-[420px] max-h-[85vh] flex flex-col overflow-hidden"
      >
        <div className="!bg-[#714DFF] flex items-center gap-[10px] px-[20px] py-[16px]">
          <div className="w-[34px] h-[34px] rounded-full flex items-center justify-center shrink-0">
            <img src="./asset/izibnpl-white.svg" />
          </div>
          <div className="w-[180px] h-[34px] ml-[5px] rounded-full flex items-center justify-center shrink-0">
            <img src="./asset/IziPaySmallSmall.svg" />
          </div>
        </div>

        <div className="px-[20px] py-[16px] overflow-y-auto">
          <div className="rounded-md p-[16px] text-[14px] leading-[1.6] text-gray-700 space-y-[14px]">
            <p>
              Pay Small Small allows eligible customers to purchase products or
              equipment without paying the full cost upfront.
            </p>
            <p>
              A financial institution (finance partner) provides the full
              purchase amount, while the customer pays the required initial
              deposit. The customer then repays the amount financed to the
              Finance partner in agreed instalments.
            </p>

            <div>
              <p className="font-[700] text-black mb-[6px]">
                How Pay Small Small Works
              </p>
              <ol className="list-decimal pl-[18px] space-y-[6px]">
                <li>
                  <span className="font-[600]">Choose what you need</span> -
                  Select the product or equipment you want to purchase.
                </li>
                <li>
                  <span className="font-[600]">Apply for Pay Small Small</span>{' '}
                  - Complete the application and provide the required
                  information and KYC documents.
                </li>
                <li>
                  <span className="font-[600]">Get Assessed</span> - The finance
                  partner reviews your application and determines your
                  eligibility.
                </li>
                <li>
                  <span className="font-[600]">Pay your initial deposit</span> -
                  If approved, you pay the required deposit.
                </li>
                <li>
                  <span className="font-[600]">Receive your purchase</span> -
                  The finance partner finances the approved portion of the
                  purchase.
                </li>
                <li>
                  <span className="font-[600]">Repay in instalments</span> -
                  Repay the financed amount plus applicable interest to the
                  finance partner over the agreed tenure.
                </li>
              </ol>
            </div>

            <div>
              {companyId === Number(import.meta.env.VITE_ECS_ID) && (
                <div
                  className="flex gap-[10px]  
              items-start
              bg-[#F5F7FF] border border-[#DCE6FF] border-[1px] rounded-lg
              p-[10px] mb-[10px]"
                >
                  <div>
                    <img
                      src="./asset/ecs.png"
                      alt="fers"
                      className="rounded-full w-[60px] object-contain"
                    />
                  </div>
                  <div>
                    <div
                      className="flex gap-[10px] items-center mb-[4px]
                  content-center align-center"
                    >
                      <div className="bg-[#2563EB] text-white font-[600] text-[12px] px-[10px] py-[4px] rounded-full w-fit">
                        12% OFF
                      </div>
                      <div className="font-[800] text-[12px] text-[#2563EB]">
                        FERS Exclusive offer
                      </div>
                    </div>
                    <div className="text-[#171334] font-[500] text-[12px] mt-[10px] space-y-[8px]">
                      <p>
                        Get a 12% discount on your total Pay Small Small
                        interest when you pay in instalments over 3–12 months.
                      </p>
                      <div>
                        <p className="font-[700]">
                          Example: How Your Discount Works
                        </p>
                        <p>
                          If your standard interest rate is 3.5% per month and
                          you choose a 12-month repayment plan
                        </p>
                      </div>
                      <ul className="space-y-[2px]">
                        <li>
                          <span className="font-[600]">
                            Standard total interest:
                          </span>{' '}
                          3.5% × 12 months = 42%
                        </li>
                        <li>
                          <span className="font-[600]">Interest discount:</span>{' '}
                          12%
                        </li>
                        <li>
                          <span className="font-[600]">
                            Discounted total interest:
                          </span>{' '}
                          42% − 12% = 30%
                        </li>
                        <li>
                          <span className="font-[600]">
                            Effective monthly interest:
                          </span>{' '}
                          30% ÷ 12 months = 2.5%
                        </li>
                      </ul>
                      <p className="font-[700] text-[#2563EB]">
                        You pay 2.5% interest instead of 3.5% monthly.
                      </p>
                      <p className="italic text-gray-500">
                        Your actual interest rate and repayment terms may vary
                        depending on the financing provider and repayment
                        period.
                      </p>
                    </div>
                  </div>
                </div>
              )}
              <p className="font-[700] text-black mb-[6px]">
                Our Pay Small Small Finance Partners
              </p>
              <div className="space-y-[10px]">
                <div className="border border-gray-100 rounded-md p-[10px]">
                  <p className="font-[600] text-black mb-[4px]">
                    Finance Partner - Sparkle Microfinance Bank
                  </p>
                  <ul className="list-disc pl-[18px] space-y-[2px]">
                    <li>Maximum Amount - 12M</li>
                    <li>Maximum Tenure - 12 Months</li>
                    <li>
                      Monthly Interest -
                      {companyId !== Number(import.meta.env.VITE_ECS_ID) && (
                        <span> 3.5%</span>
                      )}
                      {companyId === Number(import.meta.env.VITE_ECS_ID) && (
                        <span> Up to 2.5%</span>
                      )}
                    </li>
                    <li>Minimum Initial Deposit - 15%</li>
                  </ul>
                  <p className="italic text-gray-500 mt-[4px]">
                    Other charges may apply
                  </p>
                </div>

                <div className="border border-gray-100 rounded-md p-[10px]">
                  <p className="font-[600] text-black mb-[4px]">
                    Finance Partner - Fast Credit Finance Company Limited
                  </p>
                  <ul className="list-disc pl-[18px] space-y-[2px]">
                    <li>Maximum Amount - 3M</li>
                    <li>Maximum Tenure - 12 Months</li>
                    <li>
                      Monthly Interest -{' '}
                      {companyId !== Number(import.meta.env.VITE_ECS_ID) && (
                        <span className="text-black">4%</span>
                      )}
                      {companyId === Number(import.meta.env.VITE_ECS_ID) && (
                        <span>Up to 3.0%</span>
                      )}{' '}
                    </li>
                    <li>Minimum Initial Deposit - 15%</li>
                  </ul>
                  <p className="italic text-gray-500 mt-[4px]">
                    Other charges may apply
                  </p>
                </div>
              </div>
            </div>

            <div>
              <p className="font-[700] text-black mb-[6px]">
                Why Choose Pay Small Small?
              </p>
              <ol className="list-decimal pl-[18px] space-y-[4px]">
                <li>
                  Access products and equipment without paying the full amount
                  upfront.
                </li>
                <li>Spread payments over an agreed period.</li>
                <li>Better manage your cash flow.</li>
                <li>
                  Get financing based on your eligibility and the finance
                  partner&apos;s assessment.
                </li>
              </ol>
            </div>

            <div>
              <p className="font-[700] text-black mb-[6px]">
                What Do You Need to Apply?
              </p>
              <p className="mb-[8px]">
                Requirements vary by finance partner and may include:
              </p>
              <p className="mb-[6px]">
                <span className="font-[600] text-black">Sparkle:</span> Biodata,
                Government ID, Bank Statement, Utility Bill, KYC verification,
                and other required information.
              </p>
              <p>
                <span className="font-[600] text-black">Fast Credit:</span>{' '}
                Biodata, Government ID, Bank Statement, Utility Bill, KYC
                verification, and other required information.
              </p>
            </div>

            <p className="italic text-gray-500">
              Please Note - Pay Small Small approval, financing amount, interest
              rate and repayment terms are subject to the applicable finance
              partner&apos;s assessment and approval. Additional requirements
              may apply.
            </p>
          </div>
        </div>
      </Popup>

      {storeInfo &&
        storeInfo.paymentMethods &&
        storeInfo.paymentMethods.length > 0 &&
        !storeInfo.isStorefrontLoginDisabled &&
        !isPaySmallSmallBarHidden && (
          <div
            className="bg-[#714DFF] min-h-[45px]
        flex content-center relative border-b-[2px] border-b-white
        justify-center items-center py-[10px] px-[10px]"
          >
            <div
              className="text-white flex gap-[5px] flex-wrap text-center
              justify-center"
            >
              <button
                className={`!bg-transparent absolute top-[15px] w-[12px] right-[15px] 
                      w-[15px] text-gray-500 hover:text-gray-700
                      flex content-center items-center
                      p-0 cursor-pointer hover:!bg-transparent hover:border-0`}
                aria-label="close button"
                onClick={() => {
                  const midnight = new Date();
                  midnight.setHours(24, 0, 0, 0);
                  Cookies.set(PAY_SMALL_SMALL_BAR_COOKIE, 'true', {
                    expires: midnight,
                  });
                  setIsPaySmallSmallBarHidden(true);
                }}
                type="button"
              >
                <img
                  src={CancelIcon}
                  className="w-[15px] h-[15px]"
                  alt="cancel"
                />
              </button>
              You can now <span className="font-[800]">Pay Small Small</span> in
              easy installments.
              <div
                className="text-[#FFDF20] cursor-pointer"
                onClick={() => setShowPaySmallSmallInfo(true)}
              >
                {' '}
                Click to learn more →
              </div>
            </div>
          </div>
        )}
    </div>
  );
}
